import PropTypes from 'prop-types';
import { getFormattedNumber } from 'utils/clickme';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import { Link } from '@hh.ru/redux-spa-middleware';

import BlokoLink, { LinkKind } from 'bloko/blocks/link';

import KMNumber from 'components/KMNumber';

import AccountLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/AccountLink';
import EmployerLink from 'components/Admin/Invoices/InvoicesTable/Invoice/Account/EmployerLink';
import { ActAdvertisingServiceType, ActProductType } from 'components/Admin/Reports/ActsReport/Labels';
import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

import { InvoiceDreamPayerType } from 'store/models/invoices';


const ManualInvoice = ({
    invoiceId,
    createdAt,
    accountId,
    employerId,
    advertisingServiceType,
    productType,
    userId,
    number,
    amount,
    discountAmount,
    clicks,
    bonusClicks,
}) => {
    return (
        <TableRow>
            <TableCell>
                <BlokoLink Element={Link} kind={LinkKind.Tertiary} to={`/new/admin/invoices/${invoiceId}/`}>
                    {invoiceId}
                </BlokoLink>
            </TableCell>
            <TableCell>{formatDate(createdAt, VIEW_DATE_FORMAT)}</TableCell>
            <TableCell>
                <EmployerLink employerId={employerId} />
            </TableCell>
            <TableCell>
                <ActAdvertisingServiceType advertisingServiceType={advertisingServiceType} />
            </TableCell>
            <TableCell>
                <ActProductType productType={productType} />
            </TableCell>
            <TableCell>
                <AccountLink accountId={accountId} />
            </TableCell>
            <TableCell>
                <KMNumber userId={userId} payerType={InvoiceDreamPayerType.Legal} number={number} withLabel />
            </TableCell>
            <TableCell>{getFormattedNumber(amount)}</TableCell>
            <TableCell>{getFormattedNumber(discountAmount)}</TableCell>
            <TableCell>{clicks}</TableCell>
            <TableCell>{bonusClicks}</TableCell>
        </TableRow>
    );
};

ManualInvoice.propTypes = {
    invoiceId: PropTypes.number,
    createdAt: PropTypes.string,
    accountId: PropTypes.number,
    employerId: PropTypes.number,
    advertisingServiceType: PropTypes.string,
    productType: PropTypes.string,
    userId: PropTypes.number,
    number: PropTypes.number,
    amount: PropTypes.number,
    discountAmount: PropTypes.number,
    clicks: PropTypes.number,
    bonusClicks: PropTypes.number,
};

export default ManualInvoice;
